export default __webpack_public_path__ + "static/media/double-leaf.7edd682a.svg";